/* Surgia Eco draft: relocate the existing BSS widget without cloning it. */
(() => {
  if (window.__surgiaBssAnnouncementMount) return;
  window.__surgiaBssAnnouncementMount = true;
  const slotSelector = '.surgia-bss-currency-slot';
  const widgetSelector = '.bss-currency-wrapper';
  let scheduled = false;
  function mount() {
    scheduled = false;
    const slot = document.querySelector(slotSelector);
    if (!slot) return;
    const widget = Array.from(document.querySelectorAll(widgetSelector))
      .find(el => el.closest(slotSelector) || el.querySelector('#switcher, .bss-nice-select'));
    if (widget && widget.parentNode !== slot) slot.appendChild(widget);
  }
  function scheduleMount() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(mount);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMount, { once: true });
  } else scheduleMount();
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches?.(widgetSelector) || node.querySelector?.(widgetSelector))
      )) { scheduleMount(); return; }
    }
  });
  const start = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
